import { createTheme } from '@mui/material/styles';
import type {} from '@mui/x-date-pickers/themeAugmentation';
import { colorPalette, fontFamily, fontSize, getSpacing } from 'stylesheet';

export const muiTheme = createTheme({
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          fontFamily: fontFamily.main,
          fontSize: fontSize.p1,
          lineHeight: '1.5',
          backgroundColor: colorPalette.white,
          padding: 0,
          '&.Mui-error': {
            borderColor: colorPalette.status_error,
          },
        },
        input: {
          padding: `${getSpacing(1)} ${getSpacing(2)}`,
        },
        multiline: {
          padding: `${getSpacing(1)} ${getSpacing(2)}`,
        },
        adornedEnd: {
          paddingRight: 0,
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        contained: {
          margin: `${getSpacing(0.5)} 0`,
          marginLeft: 0,
          fontFamily: fontFamily.main,
          fontSize: fontSize.p3,
          lineHeight: '1.5',
          color: colorPalette.status_error,
        },
        root: {
          fontFamily: fontFamily.main,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          height: 'auto',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: fontFamily.main,
        },
        body1: {
          fontFamily: fontFamily.main,
        },
      },
    },
    MuiPickersDay: {
      styleOverrides: {
        root: {
          fontFamily: fontFamily.main,
          '&.Mui-selected': {
            backgroundColor: colorPalette.secondary_500,
            color: colorPalette.greyMain,
            '&:hover': {
              backgroundColor: colorPalette.secondary_600,
            },
            '&:focus': {
              backgroundColor: colorPalette.secondary_500,
            },
          },
        },
      },
    },
    MuiPickersCalendarHeader: {
      styleOverrides: {
        label: {
          fontFamily: fontFamily.main,
          fontSize: '14px',
        },
      },
    },
    MuiDayCalendar: {
      styleOverrides: {
        weekDayLabel: {
          fontFamily: fontFamily.main,
          fontSize: '12px',
        },
      },
    },
  },
});
